/**
 * The sample call (design system Components · 09): what "See how Aria
 * answers" plays out on the Calls page as a live call — a labelled sample,
 * never a real caller. Only what the product would say; the caller's first
 * line is the landing story's first ring. Turn offsets are a reading pace
 * (about 55ms a character plus a beat), so the call lasts about twenty
 * seconds and ends handled.
 */
export const SAMPLE_CALL_ID = 'sample-call'
export const SAMPLE_CALLER = 'Marcus Reyes'

export interface SampleTurn {
  who: 'caller' | 'aria'
  text: string
  /** Seconds after the call started. */
  at: number
}

export interface SampleLive {
  turns: SampleTurn[]
  /** How many turns have arrived. */
  shown: number
  ended: boolean
  /** "What happened", once the call has ended. */
  summary: string
}

export const SAMPLE_SUMMARY =
  'Booked Thursday at 9:00 AM for a dripping kitchen sink at 418 Maple Avenue, and texted the booking link.'

/** Seconds from the start to the end of the sample call. */
export const SAMPLE_END_AT = 20

export function sampleTurns(owner: string): SampleTurn[] {
  return [
    { who: 'caller', at: 0.8, text: 'Hi — I’ve got a sink that won’t stop dripping. Can someone come out this week?' },
    { who: 'aria', at: 6, text: 'I can help with that. Is it the kitchen or a bathroom sink, and what’s the address?' },
    { who: 'caller', at: 11.4, text: 'Kitchen. 418 Maple Avenue.' },
    { who: 'aria', at: 13.9, text: `Thanks. Thursday at 9 is open — I’ll text you a booking link and let ${owner} know.` },
  ]
}

/** Aria's status line while the sample is on the line, by turns arrived. */
export function sampleStatus(shown: number): string {
  if (shown < 2) return 'Answering · a caller with a dripping sink'
  if (shown < 4) return 'Asking which sink, and the address'
  return 'Booking Thursday at 9 · texting the link'
}
